export default function Sass_Nesting() {
  return (
    <div>
      <h1>Sass Nesting</h1>
    </div>
  );
}
